// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"16807f48","453":"e95585d7","656":"1d3f812c","732":"d2e774f1","970":"fdee6533","977":"30856e2d"}[chunkId] + ".chunk.js";
};